/**
 * brandingIconSingleton.js
 * Created by Destin Frasier 10/05/17
 */

import { IconSingleton } from '../iconSingleton';

class BrandingIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-branding.loaded';
        this.svgPath = `${process.env.CDN}/graphics/brandingIcons.svg`;
    }
}

const instance = new BrandingIconSingleton();
export default instance;
